import { Box, FormControl, styledComponent } from '@hermes/web-components'

export const AddBookContainer = styledComponent(Box)(({ theme }) => ({
  padding: '16px 24px 0',
  maxHeight: '70vh',
  overflowY: 'auto',
  [theme.breakpoints.down('xs')]: {
    padding: '16px 16px 0'
  }
}))

export const RadioFormControl = styledComponent(FormControl)(({ theme }) => ({
  width: '100%',
  marginTop: '16px',
  marginBottom: '43px',
  '.MuiFormGroup-root': {
    width: '100%',
    label: {
      marginLeft: 0,
      gap: '10px',
      padding: '12px 5px',
      marginRight: '0',
      borderBottom: `1px solid ${theme.palette.divider}`,
      span: {
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 500
      }
    }
  }
}))
